import { useBreakpointValue } from '@chakra-ui/react';

export const useIsMobile = () => {
    const isMobile = useBreakpointValue(
        {
            base: true,
            sm: false,
        },
        {
            fallback: 'md',
            ssr: true,
        }
    );

    return isMobile;
};
